import { CreditAgreement } from '@finley-technologies/finley-types';

import { UploadedDocumentTypeGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { StrictFieldValues } from 'packages/common-frontend/components/InputsBETA/types';

export type PartyType =
  | 'borrower'
  | 'capitalProvider'
  // | 'lenderAdministrativeAgent' // BE doesn't yet support these partyTypes, but they will come later.
  // | 'administrativeAgent'
  | 'servicer'
  | 'verificationAgent';

export type Organization = {
  id: string;
  slug: string;
  name: string;
};

export type Party = Organization & {
  type: PartyType;
};

export const PARTY_OPTIONS: { value: PartyType; label: string }[] = [
  { value: 'borrower', label: 'Borrower' },
  { value: 'capitalProvider', label: 'Capital Provider' },
  // { value: 'lenderAdministrativeAgent', label: 'Lender, Administrative Agent' },
  // { value: 'administrativeAgent', label: 'Administrative Agent' },
  { value: 'servicer', label: 'Servicer' },
  { value: 'verificationAgent', label: 'Verification Agent' },
];

export type CreditAgreementFullArtifact = CreditAgreement.DomainEntity.CreditAgreementFullArtifact;

/** **************** DOCUMENT UPLOAD TYPE ****************** */
export const UPLOADED_DOCUMENT_TYPE_TO_LABEL: Record<
  UploadedDocumentTypeGQLType,
  string
> = {
  participationAgreement: 'Participation Agreement',
  creditAgreement: 'Credit Agreement',
};

export type DiffableFormData<FormDataT extends StrictFieldValues> = {
  wipForm: FormDataT;
  diffForm: FormDataT | undefined;
};
